import React from 'react';
import {
  Container,
  Heading,
  Section,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { useParams } from 'react-router-dom';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { ParentAdminOverviewHeader } from 'src/components/enterprise/Parents/Admin/ParentAdminOverviewController/ParentAdminOverviewHeader/ParentAdminOverviewHeader';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { useGetParentAccountsRedirectUrl } from 'src/components/enterprise/Parents/Admin/hooks/useGetParentAccountsRedirectUrl/useGetParentAccountsRedirectUrl';

export const ParentAdminOverviewController: React.FC = () => {
  const { corpid: corpId, dinerId } =
    useParams<{ corpid: string; dinerId: string }>();

  const parentAccountsUrl = useGetParentAccountsRedirectUrl();

  return (
    <Container variant="default">
      <Section inset="sm">
        <PageHeader>
          <Stack y="x-sm">
            <Heading variant="h2">Admin details</Heading>
          </Stack>
          <Breadcrumbs
            breadcrumbs={[
              parentAccountsUrl,
              {
                label: 'Parent admins',
                href: `/corporate/enterprise/parents/${corpId}/admin`,
                useRouterLink: true,
              },
            ]}
          />
        </PageHeader>
        <Stack y="md">
          <PageSection>
            <ParentAdminOverviewHeader corpId={corpId} dinerId={dinerId} />
          </PageSection>
        </Stack>
      </Section>
    </Container>
  );
};
